module.exports = "/_next/static/images/hayley-b29522a2b6ce3d6827696d069972b11e.jpg";